"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SearcherDateCarousel["default"];
  }
});
var _SearcherDateCarousel = _interopRequireDefault(require("./SearcherDateCarousel"));